export default __webpack_public_path__ + "static/image-AI-API-4005e39f1c7fa3eb95ba1552fa7f3733.png";